import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Calculatrice des facteurs - Calculez les facteurs primaires";
const DESCRIPTION =
  "Calculatrice des facteurs - Calculez les facteurs primaires pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "des facteurs les facteurs primaires, calculatrice des facteurs les facteurs primaires, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/factors-calculator";
const FactorsCalculator = () => {
  const [number, setNumber] = useState("");
  const [factors, setFactors] = useState([]);
  const [primeFactors, setPrimeFactors] = useState([]);
  const [error, setError] = useState("");
  const calculateFactors = (num) => {
    const factorsList = [];
    for (let i = 1; i <= Math.sqrt(num); i++) {
      if (num % i === 0) {
        factorsList.push(i);
        if (i !== num / i) {
          factorsList.push(num / i);
        }
      }
    }
    return factorsList.sort((a, b) => a - b);
  };
  const primeFactorsSteps = (num) => {
    const factors = [];
    for (let i = 2; i <= num; i++) {
      while (num % i === 0) {
        factors.push(i);
        num = num / i;
      }
    }
    return factors;
  };
  const handleCalculate = () => {
    try {
      const num = parseInt(number, 10);
      if (isNaN(num) || num <= 0) {
        throw new Error("Veuillez entrer un nombre entier positif.");
      }
      const factorsList = calculateFactors(num);
      const primeFacts = primeFactorsSteps(num);
      setFactors(factorsList);
      setPrimeFactors(primeFacts);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Bienvenue sur <strong>Calculatrice des facteurs primaires</strong>! Cet outil avancé vous permet de découvrir facilement et rapidement tous les facteurs d'un nombre entier positif. En utilisant cette calculatrice, vous pouvez obtenir une liste complète des facteurs, y compris les facteurs primaires, ce qui améliore votre compréhension de la structure des nombres et comment les analyser into leurs componentes essentielles.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div className="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label me-2">
                          Entrez un nombre
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="Exemple: 24"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginRight: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-dark">
                      Erreur : {error}
                    </p>
                  )}
                  {factors.length > 0 && (
                    <div>
                      <p className="p-3 mb-2 bg-success text-white">
                        Facteurs: {factors.join(", ")}
                      </p>
                      <p className="p-3 mb-2 bg-info text-dark">
                        Facteurs primaires: {primeFactors.join(" × ")}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce qu'un facteur ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Les facteurs sont des nombres qui se multiplient entre eux pour donner
                        un résultat. Par exemple, les facteurs de 12 sont : 1, 2, 3, 4, 6, 12,
                        car chacun divise 12 exactement. Les facteurs sont utilisés pour
                        simplifier les fractions et résoudre des problèmes mathématiques.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Les facteurs premiers</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Les facteurs premiers sont des nombres divisibles uniquement par 1
                        et par eux-mêmes. Par exemple, les facteurs premiers de 12 sont
                        2 × 2 × 3. La décomposition en facteurs premiers est la base
                        de la théorie des nombres.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
};
export default FactorsCalculator;
